import { SiteToggleButton as DefaultSiteToggleButton } from "../common/site-toggle-button";
import { SitePicker as DefaultSitePicker } from "../common/site-picker";
import { SiteNameInput as DefaultSiteNameInput } from "../common/site-name-input";
import { ReactNode } from "react";

import { css } from "@compiled/react";

import Form from "@atlaskit/form";

import { useSiteActivationContext } from "../../hooks/site-activation-context";

import { UpgradeEligibleSubmitButton as DefaultSubmitButton } from "./submit-button";

export const Content = ({
    SiteNameInput = <DefaultSiteNameInput />,
    SitePicker = <DefaultSitePicker />,
    SiteToggleButton = <DefaultSiteToggleButton />,
    SubmitButton = <DefaultSubmitButton />
}: {
    SiteNameInput?: ReactNode;
    SitePicker?: ReactNode;
    SiteToggleButton?: ReactNode;
    SubmitButton?: ReactNode;
    PrivacyPolicy?: ReactNode;
}) => {
    const { activateSite, showSitePicker } = useSiteActivationContext();

    return (
        <Form onSubmit={activateSite} isDisabled={false}>
            {({ formProps }) => (
                <form
                    {...formProps}
                    autoComplete="off"
                    css={containerCss}
                    data-testid="upgrade-eligible-site-activation"
                >
                    <div>
                        {showSitePicker ? SitePicker : SiteNameInput}
                        {SiteToggleButton}
                    </div>
                    {SubmitButton}
                </form>
            )}
        </Form>
    );
};

const containerCss = css({
    display: "grid",
    gap: "24px"
});
